import React from 'react';
import {Text} from '@chakra-ui/react';

export default function DirectoryCount({total,loading,unavailable}:{total:number;loading:boolean;unavailable:boolean}) {
  return <Text role="status" aria-label="Matching users" aria-live="polite" fontWeight="semibold" textAlign="right" ml="auto">
    {unavailable ? 'Count unavailable' : loading ? 'Updating count…' : `${total.toLocaleString()} ${total===1?'user':'users'}`}
  </Text>;
}
